import { render, staticRenderFns } from "./calcLeftTop.vue?vue&type=template&id=52b20da8&scoped=true"
import script from "./calcLeftTop.vue?vue&type=script&lang=js"
export * from "./calcLeftTop.vue?vue&type=script&lang=js"
import style0 from "./calcLeftTop.vue?vue&type=style&index=0&id=52b20da8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b20da8",
  null
  
)

export default component.exports